// extracted by mini-css-extract-plugin
module.exports = {"metrics-container":"MetricsWidget_metrics-container__2BT7n","metric":"MetricsWidget_metric__3KjP2","with-tooltip":"MetricsWidget_with-tooltip__1Rz0Q"};